export default {
  state: {
    newMark: null,
  },
  getters: {},
  mutations: {
    createMark(state, payload) {
      state.newMark = payload;
    },
    addMark(state, { index, marker }) {
      const mark = {
        ...state.newMark,
        ...marker,
      };

      if (index !== -1) {
        state.unsavedScenes[index].marks.push(mark);
      } else {
        state.selectedScene.marks.push(mark);
      }

      state.popupActivities.addMark = false;
      state.popupActivities.newMark = null;
    },
    deleteMark(state, { index, markerId }) {
      if (index !== -1) {
        state.unsavedScenes[index].marks = state.unsavedScenes[index].marks.filter(
          s => (s._id || s.id) !== (markerId)
        );
      } else {
        state.selectedScene.marks = state.selectedScene.marks.filter(
          s => s._id !== markerId
        );
      }
    },
  },
};
